<mat-toolbar class="secondary-toolbar mat-elevation-z1">
  <div *ngIf="state!='LIST'" class="secondary-toolbar-item selectable" (click)="showAllBrands()"><mat-icon>list</mat-icon> All Brands</div>
  <ng-container *ngIf="state=='EDIT'">
    <div class="secondary-toolbar-item"><mat-icon svgIcon="cw:action_next"></mat-icon>{{selectedItem.name}}</div>
  </ng-container>
</mat-toolbar>

<section class="main-content">
  <cw-ci-admin-brand-list #planList *ngIf="state=='LIST'" (stateChange)="onStateChange($event)"></cw-ci-admin-brand-list>
  <app-account-brand *ngIf="state=='EDIT' || state=='CREATE'" (stateChange)="onStateChange($event)" [brandId]="selectedItem.id"></app-account-brand>
</section>
